import app from 'ampersand-app'
import { lazy, Suspense } from 'preact/compat'
import { useRef, useState } from 'preact/hooks'
import { Modal, ModalCloseButton, ModalPanel } from '../modal/modal'
import { PreactView } from '../preact-view'

const ProductImport = lazy(() => import('./product-import'))

function ProductImportButton() {
  const [isOpen, setIsOpen] = useState(false)
  const initialFocus = useRef()

  function handleClose() {
    app.products.fetch()
    setIsOpen(false)
  }

  return (
    <>
      <button
        type='button'
        className='pure-button btn-round dispatch'
        data-title='Produkte importieren'
        onClick={() => setIsOpen(true)}
      >
        <i className='ion-ios-cloud-upload' />
      </button>

      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalPanel>
          <ModalCloseButton onClick={handleClose} />
          <h1>Produkte importieren</h1>
          <Suspense fallback={null}>
            <ProductImport onClose={handleClose} initialFocus={initialFocus} />
          </Suspense>
        </ModalPanel>
      </Modal>
    </>
  )
}

export const ProductImportButtonView = PreactView.extend({
  component: ProductImportButton
})
